import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFStream from "PDFLib/core/objects/PDFStream";
import PDFDict from "PDFLib/core/objects/PDFDict";
import {DictionaryObjectItem} from "PDFLib/core/writers/JSONWriter/JSONItem/DictionaryObjectItem";

export abstract class StreamJSONItemBase extends JSONItemBase{

    public Dict:DictionaryObjectItem;
    constructor(stream:PDFStream) {
        super();
        this.Dict=new  DictionaryObjectItem(stream.dict);

    }
}